import { FoldersListItem } from '@dc-shared-web/hooks/api/folder/types'
import { AxiosInstance } from 'axios'

type GetFoldersParams = {
  currentTeamUuid: string
  folderUuid?: string
  projectUuid?: string
}

export const fetchFoldersList = async (
  apiClient: AxiosInstance,
  params: GetFoldersParams
): Promise<FoldersListItem[]> => {
  const { data } = await apiClient.get(`/api/folders`, {
    params: {
      office_uuid: params.currentTeamUuid,
      folder_uuid: params.folderUuid,
      project_uuid: params.projectUuid,
      limit: 500,
      sortBy: 'name',
      parent_dash: !Boolean(params.folderUuid || params.projectUuid),
    },
  })
  return data?.results
}
